import { render } from "./AntiguaPage.vue?vue&type=template&id=289c9034&scoped=true"
import script from "./AntiguaPage.vue?vue&type=script&lang=js"
export * from "./AntiguaPage.vue?vue&type=script&lang=js"

import "./AntiguaPage.vue?vue&type=style&index=0&id=289c9034&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-289c9034"]])

export default __exports__